// extracted by mini-css-extract-plugin
export default {"container":"zK-z","timeTop":"AK-z","timeCountdown":"BK-z","cta":"CK-z","disabled":"DK-z","product":"EK-z"};